<template>
  <div>
      <div class="store-name">
        <div>{{repoortData.storeName}}</div>
        <div v-if="userId && userId!=='-1' && userId!=='1' " @click="customer">Customer Order</div>
      </div>
      <div class="store-address" v-if="repoortData.address">
          <img src="@/assets/img/explore/location.png"/>
          <span>{{repoortData.address}}</span>
      </div>

    <!-- 店铺图片 -->
    <div class="store-img" v-if="storeImgList && storeImgList.length>0">
      <awesome-swiper
        :pagination="pagination"
        :turnPages="turnPages"
        :swiperData="storeImg"
        :prevName="'storeImg'"
        :nextName="'storeImg'"
      >
        <swiper-slide v-for="(item, index) in storeImgList" :key="index">
            <div class="card-img"><img :src="item" @click="$refs['imgPreviewRef'].init(item)"></div>
        </swiper-slide>
      </awesome-swiper>
    </div>

    <!-- 周边行人流量（周边流量） -->
    <div class="periphery-traffic">
          <p class="content-title">local pedestrian traffic</p>
          <div>
              <div>Property:</div>
              <div class="s-name">{{repoortData.storeName}}</div>

              <div class="store-content" :class="showTraffic?'':'filter-blur'" >
                <div class="content-data" >
                    <div class="left-area">
                      <span>Store reviews</span>
                      <span class="reviews">
                        {{parseFloat(repoortData.avgRating).toFixed(1)}}
                         <el-rate
                           v-model="repoortData.avgRating"
                           disabled
                           text-color="#F3E93D">
                          </el-rate>
                          ({{Number(repoortData['reviews'])}})
                      </span>
                    </div>
                    <div class="right-area">
                      <span>Median House Value</span>
                      <span v-format="'$#,##.##k'">{{(repoortData['medianHomeValue']?(repoortData['medianHomeValue']/1000):0)}}</span>
                    </div>
                </div>
                <div class="content-data"  style="margin-bottom: 10px;">
                <div class="left-area">
                  <span>Median rent</span>
                  <span>{{(repoortData['medianGrossRent']?(repoortData['medianGrossRent']/1000):0).toFixed(2)}}K/Month</span>
                </div>
                <div class="right-area">
                  <span>Web site</span>
                  <span @click="openWebSite(repoortData['website'])" style="cursor: pointer;">{{ repoortData['website'] ? repoortData['website'] : 'NA' }}</span>
                </div>
              </div>
              </div>

              <div class="locked-content" v-if="!showTraffic">
                <i class="el-icon-lock"></i>
                <div @click="clickUpgrade">Upgrade To Unlock</div>
              </div>

          </div>
    </div>

    <!--  Visits Trend -->
    <div class="visits-trend">
        <p class="content-title">Ethnic composition</p>
        <div>
          <div ref="chart" style="width: 100%;height: 260px;" :class="showTrend?'':'filter-blur'"></div>

          <div class="locked-content" v-if="!showTrend">
            <i class="el-icon-lock"></i>
            <div @click="clickUpgrade">Upgrade To Unlock</div>
          </div>

        </div>

    </div>

    <!--  Audience Overview -->
    <div class="audience-overview">
      <p class="content-title">Audience Overview</p>
      <div>
        <el-table
          ref="filterTable"
          :header-cell-style="{color:'#000000',fontSize:'14px'}"
          :data="audienceTableData"
          style="width: 100%">
          <el-table-column
            prop="date"
            label="Property"
            width="auto"
            column-key="date"
          >
            <template slot-scope="scope">
              <div class="fontBond" :class="showAudienceOverview?'':'filter-blur'">
                {{scope.row.storeName}}
                <br/>
                <span class="store-address"> {{scope.row.storeAddress}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="medianHousehold"
            label="Median Household"
            width="150">
            <template slot-scope="scope">
              <div  class="fontBond" :class="showAudienceOverview?'':'filter-blur'">
                <span class="fontBond" v-format="'$#,##0.00'">{{Number(scope.row.income/1000)  }}</span>k
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="degree"
            label="Bachelor’s Degree"
            width="150">
            <template slot-scope="scope">
              <div class="fontBond" :class="showAudienceOverview?'':'filter-blur'" >
                <span class="fontBond"> {{scope.row.degree}}</span>%
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="medianAge"
            label="Median Age"
            width="150">
            <template slot-scope="scope">
              <div class="fontBond"  :class="showAudienceOverview?'':'filter-blur'">
                {{scope.row.medianAge}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="mostCommonEthnicity"
            label="Most Common Ethnicity"
            width="180">
            <template slot-scope="scope">
              <div class="fontBond"  :class="showAudienceOverview?'':'filter-blur'">
                {{scope.row.mostCommonEthnicity}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="personsPerHousehold"
            label="Persons per Household"
            width="180">
            <template slot-scope="scope">
              <div   class="fontBond" :class="showAudienceOverview?'':'filter-blur'">
                {{scope.row.personsPerHousehold}}
              </div>
            </template>
          </el-table-column>
<!--          <el-table-column
            prop="income"
            label="Income"
            width="auto">
            <template slot-scope="scope">
              <div :class="showAudienceOverview?'':'filter-blur'" >
                <span v-format="'$#,##0.00'">{{scope.row.income  }}</span>
              </div>
            </template>
          </el-table-column>-->

        </el-table>

        <div class="locked-content" v-if="!showAudienceOverview">
          <i class="el-icon-lock"></i>
          <div @click="clickUpgrade">Upgrade To Unlock</div>
        </div>
        <div class="tips">*Demographics are based on a True Trade Area capturing 70%of visits | Data source: Census 2021</div>
      </div>

    </div>

    <!--  Vicinity -->
    <div class="vicinity">
      <p class="content-title">Vicinity</p>
      <div>
        <el-table ref="vicinityTable" :data="vicinityTableData" style="width: 100%">
          <el-table-column
            prop="rank"
            label="Rank"
            width="60">
            <template slot-scope="scope">
              <div  :class="showVicinity?'':'filter-blur'" class="fontBond">
                {{scope.row.rank}}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            label="Name"
            width="auto">
            <template slot-scope="scope">
             <div style="display: flex;" :class="showVicinity?'':'filter-blur'" class="fontBond"> {{scope.row.name}} <span class="store-info">/ {{scope.row.address}}</span></div>
            </template>
          </el-table-column>

<!--          <el-table-column
            prop="distance"
            label="Distance"
            width="120">
            <template slot-scope="scope">
              <div :class="showVicinity?'':'filter-blur'" >
                  <span v-format="'#,##'">{{scope.row.distance}}</span>  mi
              </div>

            </template>
          </el-table-column>-->
          <el-table-column
            prop="visits"
            label="Visits"
            width="120">
            <template slot-scope="scope">
              <div :class="showVicinity?'':'filter-blur'" style="display: flex;" v-format="'#,##'" class="fontBond"> {{scope.row.visits}} </div>
            </template>
          </el-table-column>

        </el-table>

        <div class="locked-content" v-if="!showVicinity">
          <i class="el-icon-lock"></i>
          <div @click="clickUpgrade">Upgrade To Unlock</div>
        </div>

      </div>
    </div>

    <img-preview :src-list="storeImgList" ref="imgPreviewRef"></img-preview>
    <ai-recommendations-upgrade-plan  ref="loadMore"></ai-recommendations-upgrade-plan>

   </div>
</template>

<script>
import awesomeSwiper from '../home/components/awesomeSwiper'
import {swiperSlide} from 'vue-awesome-swiper'
import imgPreview from './img-preview'
import aiRecommendationsUpgradePlan from './ai-recommendations/ai-recommendations-upgrade-plan'

import * as echarts from 'echarts'
import {getAction, postAction} from '../../api/manage'

export default {
  name: 'explore-report',
  props: {
    userId: {
      default: '',
      type: String
    },
    storeId: {
      default: '',
      type: String
    },
    storeNameNonStoreId: {
      default: '',
      type: String
    },
    storeAddressNonStoreId: {
      default: '',
      type: String
    }
  },
  components: {
    awesomeSwiper,
    swiperSlide,
    imgPreview,
    aiRecommendationsUpgradePlan
  },
  filters: {
    usTextFormat: (value) => {
      return this.textFormat(value, '$#,##0.00')
    }

  },

  data() {
    return {
      storeImg: {
        slidesPerView: 5,
        spaceBetween: 20,
        slidesPerGroup: 5,
        loopFillGroupWithBlank: true,
        loop: false

      },
      turnPages: true,
      pagination: true,

      repoortData: {},
      showPreviewImg: false,
      showTraffic: true,
      showAudienceOverview: true,
      showVicinity: true,
      showTrend: true,
      storeImgList: [],
      audienceTableData: [
        {
          storeName: 'Sally Beauty Supply',
          storeAddress: 'Plank Rd, Altoona, PA',
          medianHousehold: '$199.99',
          degree: '10%',
          medianAge: '10%',
          mostCommonEthnicity: 'Chinese｜10%',
          personsPerHousehold: 4,
          income: '$5,000.00'

        }
      ],
      vicinityTableData: [
        {
          rank: 1,
          name: 'Logan Towne Center',
          address: '2600 Plank Rd, Altoona, PA 16601',
          distance: '2.4 mi',
          housePrice: '6.7K',
          rate: '72.5%',
          visits: 10
        },
        {
          rank: 2,
          name: 'Walmart',
          address: '2600 Plank Rd, Altoona, PA 16601',
          distance: '2.4 mi',
          housePrice: '6.7K',
          rate: '72.5%',
          visits: 10

        },
        {
          rank: 3,
          name: 'Park Hills Plaza',
          address: '275 Park Hills Plaza West Plank Roadd & Park Hills Plaza, Altoona, PA 16602',
          distance: '2.4 mi',
          housePrice: '6.7K',
          rate: '72.5%',
          visits: 10
        },
        {
          rank: 4,
          name: 'Logan Valley Mall',
          address: '5580 Goods Ln, Altoona, PA 16602',
          distance: '2.4 mi',
          housePrice: '6.7K',
          rate: '72.5%',
          visits: 10

        },
        {
          rank: 5,
          name: 'Sam’s Club',
          address: '2500 Plank Rd, Altoona, PA 16601',
          distance: '2.4 mi',
          housePrice: '6.7K',
          rate: '72.5%',
          visits: 10

        }

      ],
      trendXData: [
        'Oct 30',
        'Nov 06',
        'Nov 13',
        'Nov 20',
        'Nov 27'
      ],
      trendYData: [
        'Asian',
        'White',
        'Hispanic/Latino',
        'Other Race',
        'Black/African American',
        'Amer. Indian/Alaskan Native',
        'Two or More Races',
        'Native Hawaiian/Pacific Islander'
      ],
      ethnicOrigin: [
        {
          'name': 'Asian',
          'value': 33523
        },
        {
          'name': 'White',
          'value': 22907
        },
        {
          'name': 'Hispanic/Latino',
          'value': 20147
        },
        {
          'name': 'Other Race',
          'value': 9576
        },
        {
          'name': 'Black/African American',
          'value': 8260
        },
        {
          'name': 'Two or More Races',
          'value': 7374
        },
        {
          'name': 'Amer. Indian/Alaskan Native',
          'value': 440
        },

        {
          'name': 'Native Hawaiian/Pacific Islander',
          'value': 75
        }]

    }
  },
  methods: {
    customer() {
      window.open(window.location.origin + '/menu/CustomersDetail?userId=' + this.userId)
    },
    openWebSite(url) {
      if (url) {
        window.open(url)
      }
    },
    clickUpgrade() {
      this.$refs['loadMore'].init()
    },
    lockedAll() {
      this.showTraffic = false
      this.showAudienceOverview = false
      this.showVicinity = false
      this.showTrend = false
      this.repoortData['storeName'] = this.storeNameNonStoreId
      this.repoortData['address'] = this.storeAddressNonStoreId
      this.storeImgList = []
      this.$nextTick(() => {
        this.initTrend()
      })
    },
    loadData() {
      if (!this.storeId || this.storeId == 'null') {
        this.lockedAll()
        return
      }

      postAction('/brand/vilocal/api/v0.2/ai-recommendation/detail', {storeId: this.storeId}).then(res => {
        if (res.success) {
          this.repoortData = res.result

          this.storeImgList = this.repoortData['storeImgList']

          // local pedestrian traffic
          if (!this.repoortData['reviews'] || !this.repoortData['medianHomeValue'] || !this.repoortData['medianGrossRent']) {
            this.showTraffic = false
          }

          /**
           * audienceTableData:[
           *         {
           *           storeName:'Sally Beauty Supply',
           *           storeAddress:'Plank Rd, Altoona, PA',
           *           medianHousehold:'$199.99',
           *           degree:'10%',
           *           medianAge:'10%',
           *           mostCommonEthnicity:'Chinese｜10%',
           *           personsPerHousehold:4,
           *           income: '$5,000.00'
           *
           *         }
           *       ]
           */

          if (!this.repoortData['storeName'] || !this.repoortData['address'] || !this.repoortData['medianHouseholdIncome'] ||
             !this.repoortData['percentBachelorsDegree'] || !this.repoortData['householdSize'] || !this.repoortData['medianHouseholdIncome'] ||
            !this.repoortData['mostCommonEthnicity'] || !this.repoortData['mostCommonEthnicityPercent'] || !this.repoortData['ageMedain'] || !this.repoortData['ageMedainPercent']) {
            this.showAudienceOverview = false
          } else {
            this.audienceTableData = []
            let obj = {}
            obj['storeName'] = this.repoortData['storeName']
            obj['storeAddress'] = this.repoortData['address']
            obj['medianHousehold'] = this.repoortData['medianHouseholdIncome']
            obj['degree'] = this.repoortData['percentBachelorsDegree']

            obj['medianAge'] = `${this.repoortData['ageMedain']}(${Number(this.repoortData['ageMedainPercent'] * 100).toFixed(2)}%)`
            obj['mostCommonEthnicity'] = this.repoortData['mostCommonEthnicity'] + ' | ' + (this.repoortData['mostCommonEthnicityPercent'] * 100).toFixed(2) + '%'
            obj['personsPerHousehold'] = this.repoortData['householdSize']
            obj['income'] = this.repoortData['medianHouseholdIncome']
            this.audienceTableData.push(obj)
          }

          // Vicinity
          if (!this.repoortData['vicinityList'] || this.repoortData['vicinityList'].length == 0) {
            this.showVicinity = false
          } else {
            this.vicinityTableData = this.repoortData['vicinityList']
            let i = 1
            this.vicinityTableData.forEach((itm) => {
              itm['rank'] = i
              i++
            })
          }

          // showTrend
          if (!this.repoortData['ethnicOrigin'] || this.repoortData['ethnicOrigin'].length == 0) {
            this.showTrend = false
          } else {
            this.ethnicOrigin = this.repoortData['ethnicOrigin']
            this.trendYData = this.ethnicOrigin.map(f => f['name'])
          }
          this.initTrend()

          if (!this.repoortData['storeId']) {
            this.repoortData['storeName'] = this.storeNameNonStoreId
            this.repoortData['address'] = this.storeAddressNonStoreId
          }
        } else {
          this.lockedAll()
          this.$message.error(res.message)
        }
      })
    },
    initTrend() {
      const chart = echarts.init(this.$refs.chart)

      // 设置趋势图的配置选项
      const options = {
        title: {
          text: '柱状图',
          show: false // 隐藏图例
        },
        grid: {
          width: 'auto',
          height: 'auto',
          left: 220,
          right: '2%',
          top: 20,
          bottom: 25
        },
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.trendYData,
          axisLabel: {
            // show: false,
            // interval: 0, //强制显示所有标签
            // rotate: 45, //旋转45度，防止重叠
          }
        },
        series: [{
          data: this.ethnicOrigin, // 替换为实际数据
          type: 'bar',
          barWidth: '40%', // 控制每根柱子之间的间隙大小
          itemStyle: {
            normal: {
              color: function (params) {
                let colorList = ['#7c24f4', '#2F66FB', '#30A5FB', '#C9FD33', '#FFF636', '#FEBA2B', '#FD6C21', '#FD3B1D'] // 根据自己的需求修改颜色列表
                return colorList[params.dataIndex]
              }
            }
          }

          /*  areaStyle: {
              color: 'rgba(243,233,61,0.35)',
            },
            lineStyle: {
              color: '#F3E93D',
              width: 1, // 线条宽度
            } */
        }]

        /* tooltip: {
          trigger: 'item',
            position: 'inside',
            formatter: '{a} <br/>{b}: ({c}) ({d}%)'
        },
        color: ['#7c24f4', '#2F66FB', '#30A5FB', '#C9FD33', '#FFF636', '#FEBA2B', '#FD6C21', '#FD3B1D'],
        series: [
        {
          name: 'Ethnic Ratio',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 10,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: this.ethnicOrigin
        }
      ] */

      }

      // 设置数据和配置选项到图表实例中，并渲染图表到指定元素中
      chart.setOption(options)
    }

  },
  mounted() {
    // this.initTrend()
  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped lang="less">
.store-name{
  display: flex;
  //height: 40px;
  div{
    &:nth-child(1){
      font-size: 24px;
      font-family: Satoshi-Bold !important;
    }
    &:nth-child(2){
      margin-left: 50px;
      height: 40px;
      line-height: 40px;
      border-radius: 3px;
      width: 170px;
      background: #262B2F;
      text-align: center;
      color: #FFFFFF;
      cursor: pointer;
    }
  }
}
.store-address{
  margin-top: 10px;
  display: flex;
  height: 30px;
  align-items: center;
  img{
    width: 20px;
    object-fit: cover;
    margin-right: 10px;
  }
}

.store-img{
  padding: 0 40px;
  margin-top: 30px;

}

.content-title{
  font-family: Satoshi-Bold !important;
  font-size: 14px;
  margin-bottom: 10px;
  color: #262B2F;
}
.periphery-traffic{
  margin-top: 20px;
  p{
    font-family: Satoshi-Bold !important;
    color: #262B2F;
  }
  .s-name,.left-area,.right-area{
    font-family: Satoshi-Medium !important;
    color: #000000;
  }

  >div{
    border: 1px solid #E1E1E1;
    padding: 9px;
    position: relative;
  }
  .s-name{
    font-size: 20px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .store-content{
    position: relative;

  }
  .content-data{
    margin-top: 10px;
    display: flex;
    justify-content: space-around;
    .left-area,.right-area{
      font-size: 14px;
      padding-bottom: 7px;
      border-bottom: #E1E1E1 1px solid;
      width: 50%;
      display: flex;
      justify-content: space-between;
      span{
        font-family: Satoshi-Medium !important;
      }
    }
    .right-area{
      margin-left: 20px;
    }

  }

  .reviews{
      display: flex;
  }

}

.visits-trend{
  margin-top: 20px;

}
.audience-overview,.vicinity,.visits-trend{
  margin-top: 20px;
  >div{
    border: 1px solid #E1E1E1;
    position: relative;
  }

  /deep/ .el-table__row{
    font-family: Satoshi-Bold !important;
    color: #000000;
  }

}
.audience-overview{

  .tips{
    color: #5D5D5D;
    padding-left: 10px;
    margin: 15px 0;
  }

  .store-address {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
  }

}
.vicinity{

  .store-info,.rate {
    margin-top: 0;
    margin-left: 10px;
    position: relative;
  }
  .store-info{
    font-family: Satoshi-Regular !important;
  }
  .rate{
    margin-left: 3px;
  }

}
.locked-content {
   position: absolute;
   top: 45%;
   text-align: center;
   left: calc(50% - 90px);
   z-index: 9;
   div{
     font-family: Satoshi-Bold !important;
    margin-top: 5px;
    background: #000000;
    cursor: pointer;
    color: #FFFFFF;
    width: 180px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
}
.filter-blur{
  filter: blur(4px)
}
.fontBond{
  font-family: Satoshi-Bold !important;
}

/deep/ .has-gutter th{
  font-family: Satoshi-Regular !important;
  color: #000000 !important;
  font-weight: unset !important;

}
.card-img{
  width: 200px;
  height: 150px;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vilocal/explore-report.vue